import { ActionTree, GetterTree, Module, MutationTree } from 'vuex'
import { Actions, Getters, Mutations, ConnectivityState } from '@/interfaces/store/connectivity'
import { RootState } from '@/interfaces/store/root'
import { modalOptionsInternetError, modalOptionsRequestTimeout } from '@/model/modal-options.model'
import ModalBottomNotificationOptions from '@/interfaces/modal-bottom-notification-options'

export const state: ConnectivityState = {
  isOnline: navigator.onLine,
  isTimeout: true,
  modalOptionsRightFullPageNotification: undefined
}

export const getters: GetterTree<ConnectivityState, RootState> & Getters = {}

export const actions: ActionTree<ConnectivityState, RootState> & Actions = {
  checkOnlineStatus({ commit }) {
    const isOnline = navigator.onLine
    commit('updateOnlineStatus', isOnline)
    if (!isOnline) {
      commit('updateModalOptionsRightFullPageNotification', modalOptionsInternetError)
    }
  },
  checkRequestTimeoutStatus({ commit }) {
    const isOnline = navigator.onLine
    commit('updateRequestTimeoutStatus', true)
    if (isOnline) {
      commit('updateRequestTimeoutStatus', false)
      commit('updateModalOptionsRightFullPageNotification', modalOptionsRequestTimeout)
    }
  }
}

export const mutations: MutationTree<ConnectivityState> & Mutations = {
  updateOnlineStatus(state: ConnectivityState, isOnline: boolean) {
    state.isOnline = isOnline
  },
  updateRequestTimeoutStatus(state: ConnectivityState, isTimeout: boolean) {
    state.isTimeout = isTimeout
  },
  updateModalOptionsRightFullPageNotification(state: ConnectivityState, modalOption: ModalBottomNotificationOptions) {
    state.modalOptionsRightFullPageNotification = modalOption
  }
}

export const store: Module<ConnectivityState, RootState> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
